// Post-tour echo — a quiet idle nudge near the AI launcher.
//
// Shows "Stuck? Ask me." at most once per day, and goes permanently dark
// after 7 days OR 5 AI uses (whichever first). All of those flags live
// server-side in the tour blob; this component is presentational — the
// parent decides visibility (shouldShowEcho) and records that it was shown.

import React from 'react';
import { ECHO_COPY } from './revealStops';

export default function EchoHint({ onClick, onDismiss }) {
  return (
    <div
      className="fixed z-40 flex items-center gap-2 bg-slate-900 text-white text-xs font-semibold px-3 py-2 rounded-full shadow-lg"
      style={{ bottom: 76, right: 24 }}
      role="status"
    >
      <span className="text-indigo-300">✨</span>
      <button onClick={onClick} className="hover:underline">{ECHO_COPY}</button>
      <button onClick={onDismiss} aria-label="Dismiss" className="text-slate-400 hover:text-white ml-1">×</button>
    </div>
  );
}

export function Celebration({ onClose }) {
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4" style={{ background: 'rgba(2,6,23,0.55)' }}>
      <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 text-center">
        <div className="text-4xl mb-2">🎉</div>
        <h3 className="text-xl font-black text-slate-900">You're all set</h3>
        <p className="text-sm text-slate-600 mt-1">
          You just asked your AI its first question. It knows this app inside out — lean on it any time.
          Your setup checklist stays in the sidebar under <strong>Setup ✓</strong>.
        </p>
        <button
          onClick={onClose}
          className="w-full mt-4 bg-violet-600 hover:bg-violet-700 text-white font-bold py-2.5 rounded-lg transition-colors"
        >
          Let's go →
        </button>
      </div>
    </div>
  );
}
